import { lazy, useContext, useEffect } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import styles from './index.module.css';

import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../App';
import { EVENTCODES, pushEventToParent } from '../../../Utils/eventUtils';
import { getTenant } from '../../../Utils/storageUtils';
import { TenantType } from '../../../Utils/types';
import { ASSETSTYPE } from '../../HomePageNew';
import { isCommonTenant } from '../../CommonTenant/utils/configUtils';
import AssetDashboard from '../../CommonTenant/BOB_V2/pages/dashboard';

let dashboardLoaded = false;

const PBAssetsDasboard = lazy(() => {
  return import('../../PaisaBazaar/AssetsDashboard');
});

const CommonTenantAssetsDasboard = lazy(() => {
  return import('../../CommonTenant/AssetsDashboard');
});

const AUAssetDashboard = lazy(() => {
  return import('../../AUBank/AssetsDashboard');
});
const YesBankAssetsDasboard = lazy(() => {
  return import('../../YesBank/AssetsDashboard');
});

const MahindraDashboard = lazy(() => {
  return import('../../Mahindra/DashBoard');
});

const JFSAssetsDashboard = lazy(() => {
  return import('../../JFS/AssetsDashboard');
});

const SIBAssetsDashboard = lazy(() => {
  return import('../../SIB/AssetsDashboard');
});

type Props = {
  onClick: (assetsType: ASSETSTYPE) => void;
};

const AssetsDashboard: React.FC<Props> = ({ onClick }) => {
  const {
    setSelectedNudge,
    setIsKeyInshigtsVisible,
    selectedNudge,
    isKeyInshigtsVisible,
    goBackEventReceived,
    isAdditionalAccountJourney,
    isBackEventSent,
    setMonthlyPaymentsVisible,
    monthlyPaymentsVisible,
    setBackButtonHandler,
  }: any = useContext(AppContext);

  const navigate = useNavigate();

  const dashboardLoadEvent = () => {
    if (!dashboardLoaded) {
      dashboardLoaded = true;
      pushEventToParent({
        eventCode: EVENTCODES.DASHBOARD_LOAD,
      });
    }
    return 0;
  };

  useEffect(() => {
    dashboardLoadEvent()
  }, [])

  useEffect(() => {
    const handlebackButton = (event: any) => {
      const { data } = event;

      try {
        if (typeof data === 'string') {
          const parsedData = JSON.parse(data);
          if (
            parsedData.action === 'handleIframeBackAction' &&
            !isBackEventSent.current &&
            !isAdditionalAccountJourney &&
            getTenant() !== TenantType.AU
          ) {
            pushEventToParent({
              eventCode: EVENTCODES.BACK_BUTTON_PFMDB,
            });
            pushEventToParent({ eventCode: 'BACK_BUTTON_PRESSED' });
            navigate('/home');
          }
        }
      } catch (error) {
        // captureException(error);
      }

      if (
        event &&
        event.data &&
        event.data.action &&
        event.data.action === 'handleIframeBackAction' &&
        getTenant() !== TenantType.AU &&
        !isBackEventSent.current &&
        !isAdditionalAccountJourney
      ) {
        pushEventToParent({
          eventCode: EVENTCODES.BACK_BUTTON_PFMDB,
        });
        pushEventToParent({ eventCode: 'BACK_BUTTON_PRESSED' });
        navigate('/home');
      }
    };

    // Check if it's ignosis tenant
    if (getTenant() === TenantType.PB || isCommonTenant()) {
      // Do nothing for window.onpopstate for ignosis

      // Set the back button handler for ignosis
      if (setBackButtonHandler) {
        setBackButtonHandler(() => {
          return () => {
            if (monthlyPaymentsVisible) {
              setMonthlyPaymentsVisible(false);
            } else if (selectedNudge !== undefined) {
              setSelectedNudge(undefined);
              isBackEventSent.current = true;
            } else if (isKeyInshigtsVisible) {
              pushEventToParent({ eventCode: EVENTCODES.BACK_BUTTON_INSIGHTS });
              setIsKeyInshigtsVisible(false);
              isBackEventSent.current = true;
            } else {
              pushEventToParent({
                eventCode: EVENTCODES.BACK_BUTTON_PFMDB,
              });
              pushEventToParent({ eventCode: 'BACK_BUTTON_PRESSED' });
              navigate('/home');
            }
          };
        });
      }
    } else {
      window.onpopstate = () => {
        if (monthlyPaymentsVisible) {
          setMonthlyPaymentsVisible(false);
        } else if (selectedNudge !== undefined) {
          setSelectedNudge(undefined);
          isBackEventSent.current = true;
        } else if (isKeyInshigtsVisible) {
          pushEventToParent({ eventCode: EVENTCODES.BACK_BUTTON_INSIGHTS });
          setIsKeyInshigtsVisible(false);
          isBackEventSent.current = true;
        } else {
          pushEventToParent({
            eventCode: EVENTCODES.BACK_BUTTON_PFMDB,
          });
          pushEventToParent({ eventCode: 'BACK_BUTTON_PRESSED' });
          navigate('/home');
        }
      };
    }

    window.addEventListener('message', handlebackButton);

    return () => {
      window.removeEventListener('message', handlebackButton);
      window.onpopstate = () => {};
    };
  }, [
    selectedNudge,
    isKeyInshigtsVisible,
    goBackEventReceived,
    monthlyPaymentsVisible,
  ]);
  const renderDashboard = () => {
    if (isCommonTenant()) {
      if (getTenant() === TenantType.BOB_V2) return <AssetDashboard />;
      return <CommonTenantAssetsDasboard onClick={onClick} />;
    }
    switch (getTenant()) {
      case TenantType.PB:
        return <PBAssetsDasboard onClick={onClick} />;
      case TenantType.YESBANK:
        return <YesBankAssetsDasboard onClick={onClick} />;
      case TenantType.MAHINDRA:
        return <MahindraDashboard onClick={onClick} />;
      case TenantType.JFS:
        return <JFSAssetsDashboard onClick={onClick} />;
      case TenantType.AU:
        return <AUAssetDashboard onClick={onClick} />;
      case TenantType.SIB:
        return <SIBAssetsDashboard onClick={onClick} />;
      default:
        return <div>Dashboard not available</div>;
    }
  };

  useEffect(() => {
    pushEventToParent({ eventCode: EVENTCODES.DASHBOARD_VIEW });
    return () => {
      pushEventToParent({ eventCode: EVENTCODES.DASHBOARD_EXIT });
    };
  }, []);

  return <div className={styles.accountsDashboardRoot}>{renderDashboard()}</div>

};

export default AssetsDashboard;
